export const oriflame = () => {
    return (
        <div>
            Как и других MLM компаний, у Oriflame была проблема, связанная с выгрузкой большого числа электронных
            счетов-фактур. Разработать модуль для системы, в которой работает компания, крайне дорого и долго. Мы взяли
            обычную бухгалтерию, интегрировали с их учетной системой, по сути связали базой SQL. Забираются только
            данные по реализациям и выгружаются на портал. Также мы автоматизировали процесс создания электронных
            накладных — СНТ. Мы оказываем здесь также поддержку модуля 1С:зарплата и управление персоналом
        </div>
    )
}